import React from "react";
import Card from "./card";

export default function EducationCard(): React.ReactElement {
	return (
		<Card id={"EducationCard"} title={"Education"}>
			<h2>Southern Illinois University</h2>
			<h3>Bachelor's Degree</h3>
			<p>August 2019 – May 2023</p>
			<h4>Majors</h4>
			<p>Computer Science with a specialization in Distributed Computing</p>
			<p>Political Science with a specialization in International Affairs</p>
			<h4>Minors</h4>
			<p>Economics & Philosophy</p>
			<h3>PhD Program</h3>
			<p>Ongoing</p>
			<h4>Focus</h4>
			<p>I'm studying the ways in which technology contributes to atrocities around the world and what can be done
			at an international level to prevent future atrocities and hold tech companies accountable</p>
		</Card>
	);
}